/* eslint-disable no-plusplus */
/* eslint-disable no-empty */
import Swiper from 'swiper';
import { Navigation, EffectCoverflow, Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import './left-text-right-slider.scss';

export class LeftTextRightSlider {
  constructor() {
    this.init();
  }

  // Metodo rimosso: la manipolazione manuale dei cloni durante il loop è la causa principale del "salto" indietro della slide.

  init() {
    const containerEl = document.querySelector('.left-slider-swiper');
    if (!containerEl) return;

    if (containerEl.__leftTextRightSwiper) {
      try {
        containerEl.__leftTextRightSwiper.destroy(true, true);
      } catch (err) { }
      containerEl.__leftTextRightSwiper = null;
    }

    const originalSlidesCount = containerEl.querySelectorAll('.swiper-slide').length;
    // Swiper ha bisogno di almeno 3-4 slide per un loop fluido in coverflow
    const shouldLoop = originalSlidesCount >= 3;

    const swiper = new Swiper(containerEl, {
      modules: [Navigation, EffectCoverflow, Autoplay],
      loop: shouldLoop,
      centeredSlides: true,
      // Aumentiamo questo invece di creare cloni manuali
      loopedSlides: originalSlidesCount < 6 ? 6 : null,
      slidesPerView: 'auto',
      spaceBetween: 24,
      slideToClickedSlide: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      effect: 'coverflow',
      coverflowEffect: {
        rotate: 0,
        stretch: 345,
        depth: 180,
        modifier: 1,
        slideShadows: false,
      },
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      // Rimuoviamo gli observer aggressivi che possono causare lo scatto
      observer: true,
      observeParents: true,
      breakpoints: {
        0: {
          effect: 'slide',
          loop: false,
          autoplay: false,
          slidesPerView: 1.05,
          centeredSlides: false,
          spaceBetween: 12,
        },
        576: {
          effect: 'coverflow',
          loop: shouldLoop,
          coverflowEffect: {
            rotate: 0,
            stretch: 460,
            depth: 100,
            modifier: 1,
            slideShadows: false,
          },
          autoplay: false,
        },
        1200: {
          effect: 'coverflow',
          loop: shouldLoop,
          autoplay: {
            delay: 4500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
        },
      },
    });

    containerEl.__leftTextRightSwiper = swiper;

    // Gestione click sulle slide (ottimizzata)
    const handleSlideClick = (e) => {
      const slide = e.currentTarget;
      if (slide.classList.contains('swiper-slide-active')) return;

      // Usiamo slideToClickedSlide: true nelle opzioni o questo metodo:
      const slideIndex = Array.from(swiper.slides).indexOf(slide);
      swiper.slideTo(slideIndex);
    };

    const attachEvents = () => {
      swiper.slides.forEach((slide) => {
        slide.removeEventListener('click', handleSlideClick);
        slide.addEventListener('click', handleSlideClick);
        Object.assign(slide.style, { cursor: 'pointer' });
      });
    };

    swiper.on('init', attachEvents);
    swiper.on('observerUpdate', attachEvents);
    // Importante: riattaccare i click dopo che il loop ricrea i cloni
    swiper.on('loopFix', attachEvents);

    // Inizializza gli eventi se swiper è già pronto
    attachEvents();

    // Cleanup
    const cleanup = () => {
      if (containerEl.__leftTextRightSwiper) {
        containerEl.__leftTextRightSwiper.destroy(true, true);
        containerEl.__leftTextRightSwiper = null;
      }
    };
    window.addEventListener('pagehide', cleanup);
    window.addEventListener('beforeunload', cleanup);
  }
}
